'use client';
import React, {
  useCallback,
  useState,
  ReactNode, SyntheticEvent,
} from 'react';
import { Sheet } from 'react-modal-sheet';

import styles from './styles.module.scss';
import Typography from '@/components/primitives/typography';
import { XIcon } from 'lucide-react';
import { useModal } from '@/context/modal-context';

interface Props {
  header?: ReactNode;
  children?: ReactNode;
  isOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

export const BottomSheet = (props: Props) => {
    const {
      children,
      isOpen: controlledIsOpen,
      onClose,
    } = props;
    const [isTop, setTop] = useState(true);
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const isControlled = controlledIsOpen !== undefined;
    const isOpen = isControlled ? controlledIsOpen : internalIsOpen;
    const copyProps = { ...props };

    const onScroll = useCallback((e: SyntheticEvent<HTMLDivElement>) => {
      setTop(e.currentTarget.scrollTop <= 0);
    }, [setTop]);

    const handleClose = useCallback(() => {
      if (!isControlled) {
        setInternalIsOpen(false);
      }
      onClose?.();
    }, [isControlled, onClose]);

    delete copyProps.header;
    delete copyProps.children;

    return (
      <Sheet
        className={styles.root}
        isOpen={isOpen}
        onClose={handleClose}
        {...copyProps}
      >
        <Sheet.Container className={styles.container} onScroll={onScroll}>
          <Sheet.Header className={styles.sheetHeader}>
            <div className={styles.handleContainer}><div className={styles.handle}/></div>
            <div className={styles.header}>
              <div className={styles.leftElement}></div>
              <Typography className={`${styles.title} ${isTop ? '' : styles.titleScrolled}`} size="large"
                          weight="bold">{props.header}</Typography>
              <button type="button" className={`${styles.close} focus-ring`} aria-label="닫기" onClick={handleClose}>
          <XIcon size={20} />
        </button>
            </div>
          </Sheet.Header>
          {/*<Sheet.Content className={styles.content}>*/}
            {children}
          {/*</Sheet.Content>*/}
        </Sheet.Container>
      </Sheet>
    );
  }
;
